import { React } from 'react'
import { useLoaderData } from 'react-router-dom'
import { motion } from 'framer-motion'

import './Realisations.scss'

import { useDocumentTitle, useDocumentConfig } from 'hooks/useDocument'

import Hero from 'modules/Hero'
import Button from 'components/Button'
import ServicePicto from 'components/ServicePicto'
import Card from 'components/Card'
import RefletRefletBanner from 'components/RefletRefletBanner'

const Realisations = () => {
	useDocumentTitle(`Réalisations sur-mesure`)
	useDocumentConfig(`orange`, false)

	const allProjects = useLoaderData()
	const projects = allProjects.filter(p => p.sector !== 'museum')

	return (
		<motion.main
			className='realisations'
			initial={{ opacity: 0, transition: { duration: 0.3 } }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0, transition: { duration: 0.3 } }}
		>
			<Hero
				scene={4}
				scrollTo="Quelques références"
			>
				Ils nous font confiance<br />
				pour leur projet numérique
			</Hero>

			<section className='realisations-presentation columns valign-center'>
				<div className='column-twothird align-left mobile-margin-bottom'>
					<h1>Quelques références</h1>
					<p>
						Applications mobiles, sites vitrines, solutions web complexes... Nous développons des projets numériques variés avec un objectif commun&nbsp;: créer des outils qui répondent précisément à vos enjeux et à ceux de vos utilisateurs.
					</p>
				</div>
				<div className='column-third align-right mobile-align-center'>
					<ServicePicto
						version="design"
						size="big"
					/>
				</div>
			</section>

			<section className='realisations-list columns'>
				{
					(projects.length > 0) &&
					projects.map((project, i) => (
						<div
							className='column-third align-center mobile-margin-bottom'
							key={i}
						>
							<Card
								id={project.id}
								type="realisation"
								thumbnail={`/realisations/${project.id}/thumbnail.jpg`}
								title={project.title}
								description={project.description}
								tags={project.tags}
							/>
						</div>
					))
				}

				<div className='column-full align-center'>
					<Button
						to={`${process.env.PUBLIC_URL}/nous-contacter`}
						version='2'
					>
						On en parle&nbsp;?
					</Button>
				</div>
			</section>

			<section className='realisations-museum-section'>
				<div className='section-header'>
					<h2>Nos expériences muséales et culturelles</h2>
				</div>
				
				<RefletRefletBanner />
			</section>
		</motion.main>
	)
}

export default Realisations
